<template>
    <v-card class="elevation-10">
        <v-card-title style="background:#6499faff; color: white;">
            {{ $t('membership.form') }}
            <span class="ml-5">{{ membership && membership.startDate && membership.endDate ? `${getDate(membership.startDate)} ~ ${getDate(membership.endDate)}` : '' }}</span>
            <span class="ml-5" :style="parseInt(membership.pendingAmount) === 0 ? 'color: green' : ''">{{ membership && membership.membership ? ($t('paid') + ': ' + membership.membership.price) : '' }}</span>
            <span :style="parseInt(membership.pendingAmount) > 0 ? 'color: red' : ''">{{ membership && membership.pendingAmount ? (' (' + $t('form.pending') + ': ' + membership.pendingAmount + ')' ) : '' }}</span>
        </v-card-title>
        <v-divider class="mx-4" />
        <v-card-text>
            <v-form :readonly="readOnly">
                <v-row>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="membership.name"
                            :label="$t('membership.name')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-select
                            v-model="membership.type"
                            :items="['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY']"
                            :label="$t('membership.type')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="membership.maxVisits"
                            :label="$t('maxVisits')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="membership.price"
                            :label="$t('price')"
                            :clearable="clearable"
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn :loading="loading" class="mx-2 white--text" :disabled="shouldDisableSubmit()" large color="black" @click="onSubmit">
                {{ $t('button.submit') }}
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                {{ $t('button.cancel') }}
            </v-btn>
        </v-card-actions>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-card>
</template>

<script>
    import membershipService from '@/services/membership'
    import Alert from '@/components/Alert'
    import momentTimezone from 'moment-timezone'

    export default {
        name: 'MembershipForm',
        components: { Alert },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                createdAt: null,
                membership: {},
                mandatoryField: [
                    v => !!v || 'Field is required'
                ],
                search: null
            }
        },
        computed: {
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            if (this.$route.params.membershipId) {
                membershipService.getMembership(this.$route.params.membershipId).then(resp => {
                    this.membership = resp.data
                })
            }
        },
        methods: {
            updateMembership() {
                this.dialog = false
                membershipService.getMembership(this.$route.params.membershipId).then(resp => {
                    this.membership = resp.data
                })
            },
            openDialog(data) {
                this.dialog = true
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return false
            },
            onEdit() {
                this.$router.push(`/memberships/${this.membership.id}/edit`)
            },
            createMembership() {
                membershipService.createMembership(this.membership).then(membershipResponse => {
                    this.loading = false
                    this.$router.push(`/memberships`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editMembership() {
                membershipService.updateMembership(this.$route.params.membershipId, this.membership).then(membershipResponse => {
                    this.loading = false
                    this.$router.push(`/memberships`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            async onSubmit() {
                this.loading = true
                if (this.createdAt) {
                    this.membership.createdAt = momentTimezone(this.createdAt).tz('Europe/Athens').format('DD/MM/YYYY').toString()
                }
                if (this.mode === 'edit') {
                    this.editMembership()
                } else if (this.mode === 'create') {
                    this.createMembership()
                } else {
                    this.createMembership()
                }
            },
            setCreatedAt(date) {
                this.createdAt = momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
